import React from 'react';
import {t} from '@lingui/core/macro';

import Plug from '../Plug/Plug';
import PlugCreateButton from '../PlugCreateButton/PlugCreateButton';

interface PlugEmptyProps {
    onCreate: () => void;
    buttonText: string;
}

const PlugEmpty: React.FC<PlugEmptyProps> = ({onCreate, buttonText}) => {
    return (
        <Plug
            icon={<img src="/images/MonitorsPlug.svg" alt=""/>}
            title={t`Здесь пока ничего нет`}
            text={t`Добавьте первый элемент, чтобы начать мониторинг.`}
            action={
                <PlugCreateButton onClick={onCreate}>
                    {buttonText}
                </PlugCreateButton>
            }
        />
    );
};

export default PlugEmpty;
